module.exports = __webpack_public_path__ + "media/images/card_backgrounds/bachelor_degree-3eb0ce06150f8d372d9d08d125ea9d6d.png";